/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product group.
 */
import { mapGetters } from 'vuex';
import batchService from './../../../../services/batch';
import recipeService from './../../../../services/recipe';
import batchTransformer from './../../../../transformers/batch';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        recipeId: {
          value: '',
          type: 'select',
        },
        batchNumber: {
          value: '',
          type: 'number',
        },
        status: {
          value: '',
          type: 'hidden',
        },
        plannedStartingDate: {
          type: 'date',
          value: '',
        },
        startDate: {
          type: 'date',
          value: '',
        },
        endDate: {
          type: 'date',
          value: '',
        },
        bestBeforeDate: {
          type: 'date',
          value: '',
        },
        notes: {
          value: '',
          type: 'textarea',
        },
      }),
      loading: false,
    };
  },

  created() {
    if (!this.form.status) {
      Object.keys(this.form.fields).forEach((field) => {
        this.form.hideField(field);
      });
    }
    this.loading = true;

    Promise.all([
      recipeService.all().then(() => {
        this.loading = false;
      }),
      batchService.nextBatchNumber(),
    ]).then((data) => {
      this.loading = false;
      this.form.batchNumber = data[1];
    }).catch(() => {
      this.loading = false;
    });
  },

  computed: {
    ...mapGetters({
      recipes: 'allRecipes',
    }),
  },

  watch: {
    recipes(recipes) {
      this.form.setOptions('recipeId', recipes.map(c => ({
        id: c.id,
        name: c.name,
      })));
    },

  },

  methods: {
    handleStatusChange(status) {
      this.form.showField('recipeId');
      this.form.showField('notes');
      switch (status) {
        case 'planned':
          this.form.showField('startDate');
          this.form.showField('endDate');
          this.form.hideField('batchNumber');
          this.form.hideField('bestBeforeDate');
          this.form.showField('plannedStartingDate');
          break;
        case 'started':
          this.form.showField('batchNumber');
          this.form.hideField('bestBeforeDate');
          this.form.hideField('startDate');
          this.form.hideField('endDate');
          this.form.hideField('plannedStartingDate');
          break;
        default:
          this.form.showField('batchNumber');
          this.form.showField('startDate');
          this.form.showField('endDate');
          this.form.showField('bestBeforeDate');
          this.form.hideField('plannedStartingDate');
          break;
      }
    },
    /**
     * Method to store the product group.
     */
    store() {
      this.form.loading = true;
      const batch = batchTransformer.send(this.form.data());
      batchService.store(batch)
        .then((response) => {
          this.form.loading = false;
          this.$message({
            message: this.$t('static.batches.create.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'production.batches.view',
            params: {
              id: response.id,
            },
          });
        }).catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },
    camalize(str) {
      return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/batches/create/create.js